/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'


const activityItem = css`
    .ms-Persona-imageArea, .ms-Image, .ms-Persona-initials,.ms-Image-image{
        width: 38px; 
        height: 38px;
    }
    .ms-Persona-imageArea{
        border-radius: 50%;
        overflow: hidden;
    }
    .ms-Persona-initials{
        span{
            color: #fff;
        }
    }
    .ms-ActivityItem-activityTypeIcon{
        align-items: flex-start !important;
    }
    &.ms-ActivityItem .ms-ActivityItem-commentText {
        color: var(--colorNeutralForeground3);
    }
    &.ms-ActivityItem .ms-ActivityItem-activityText{
        color: var(--colorNeutralForeground2);
    }
    `

function ActivityItem({ comments, timeStamp, activityPersonas, activityDescription }) {
    return (
        <div className="ms-ActivityItem" css={ activityItem }>
            <div className="ms-ActivityItem-activityTypeIcon">
                <div className="ms-ActivityItem-personaContainer">
                    {activityPersonas.map(x => <div className="ms-Persona-coin ms-ActivityItem-activityPersona">
                        <div className="ms-Persona-imageArea">
                            {x.imageUrl && <div className="ms-Image ms-Persona-image">
                                <img className="ms-Image-image is-loaded ms-Image-image--cover ms-Image-image--portrait is-fadeIn " src={x.imageUrl} alt="" />
                            </div>}
                            {!x.imageUrl && <div className="ms-Persona-initials flexcenter" style={{ backgroundColor: x.avatarColor }}>
                                <span>{x.imageInitials}</span>
                            </div>}
                        </div>
                    </div>)}
                </div>
            </div>
            <div className="ms-ActivityItem-activityContent">
                <span className="ms-ActivityItem-activityText">{activityDescription}</span>
                <div className="ms-ActivityItem-commentText">{comments}</div>
                <div className="ms-ActivityItem-timeStamp">{timeStamp}</div>
            </div>
        </div>
    );
};

export default ActivityItem;
